module.exports = __webpack_public_path__ + "img/moroccan.f5871d13.png";